import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { h5, paragraphLarge } from '@helpers/typography';
import styled from 'styled-components';
import ButtonStyles from '../Buttons/Button/Button.styles';
import FormStyles from '../Misc/Forms/Form.styles';
import { ContentType } from '../Misc/SectionWrapper/SectionWrapper';
const Container = styled.section `
  --propertyColour: ${brand.green.default};

  &[data-type=${ContentType.Savings}] {
    --propertyColour: ${brand.blue.dark};
  }

  border-top: 1px solid ${brand.grey.dark};
  padding-top: 24px;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${until(Device.MobileLarge)} {
    ${ButtonStyles.Container} {
      text-align: center;
      justify-content: center;
    }
  }

  @media ${from(Device.MobileLarge)} {
    align-items: flex-start;
  }
`;
const Property = styled.div ``;
const Label = styled.p `
  ${paragraphLarge};
  ${fonts.proximaNova.bold};

  margin: 0 0 8px;
`;
const Value = styled.p `
  ${h5};

  display: inline-flex;
  align-items: center;
  gap: 12px;
  color: var(--propertyColour);
  margin: 0;
`;
const Info = styled(FormStyles.Info) `
  margin: 0 0 ${fluid(4, 5)};

  &:focus-visible,
  &.focus-ring {
    outline-color: var(--propertyColour);
  }
`;
const InfoButton = styled(FormStyles.InfoButton) `
  background-color: var(--propertyColour);
`;
const Tooltip = styled(FormStyles.Tooltip) `
  left: -24px;
`;
const CalculatorResponseStyles = {
    Container,
    Info,
    InfoButton,
    Label,
    Property,
    Tooltip,
    Value,
};
export default CalculatorResponseStyles;
